export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_21-8ca417732f427ba6e8b673168a47eed6.jpg";